module.exports = __webpack_public_path__ + "img/HRK.3e56776d.svg";